export default __webpack_public_path__ + "static/media/face-recognition.55460182.svg";